import { Modal, type ModalProps } from "@chakra-ui/react";
import { useLayoutEffect } from "react";
import { purgeOrphanedChakraModalLayers } from "../../utils/chakraModalCleanup";
import { igniteChakraModalProps, wrapChakraModalOnClose } from "../../utils/chakraModalProps";

/**
 * Chakra Modal that unmounts when closed so closed dialogs do not leave ghost portal layers.
 */
export function IgniteChakraModal({
  isOpen,
  onClose,
  children,
  ...props
}: ModalProps) {
  useLayoutEffect(() => {
    if (isOpen) return;
    purgeOrphanedChakraModalLayers({ force: true });
    const t = window.setTimeout(() => purgeOrphanedChakraModalLayers({ force: true }), 50);
    return () => window.clearTimeout(t);
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      {...igniteChakraModalProps}
      {...props}
      isOpen
      onClose={wrapChakraModalOnClose(onClose)}
      blockScrollOnMount={false}
    >
      {children}
    </Modal>
  );
}
